import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import LayersIcon from "@mui/icons-material/Layers";
import Accordion from "../../../components/Containers/Accordion";
import { useState } from "react";
import { useTranslationApp } from "../../../lib/i18next";
import {
  CAMPAIGN_APPROVAL_ENTITY_COMMENTS_COUNT,
  CAMPAIGN_APPROVAL_ENTITY_COMMENTS_COUNT_SINGLE,
  CAMPAIGN_APPROVAL_ENTITY_CREATIVES_COUNT,
  CAMPAIGN_APPROVAL_ENTITY_CREATIVES_COUNT_SINGLE,
  CAMPAIGN_APPROVAL_ENTITY_TEXTS_COUNT,
  CAMPAIGN_APPROVAL_ENTITY_TEXTS_COUNT_SINGLE,
} from "../../../i18n/keysTranslations";
import ApprovalEntityCard from "./ApprovalEntityCard";
import {
  countEntityComments,
  formatApprovalCountLabel,
  getEntityAdName,
  getEntityAdGroupName,
  isApprovalAssetsGroupEntity,
} from "../utils";

const AdAccordion = ({
  token = "",
  campaignID = "",
  entity,
  comments = [],
  currentDraftID = "",
  commentsLocked = false,
  isSubmittingComment = false,
  onSubmitSpecificComment,
}) => {
  const { t } = useTranslationApp();
  const [isExpanded, setIsExpanded] = useState(false);
  const isAssetsGroup = isApprovalAssetsGroupEntity(entity);
  const accordionTitle = isAssetsGroup
    ? getEntityAdGroupName(entity) || entity?.label || ""
    : getEntityAdName(entity);
  const textsCount = entity?.texts?.length || 0;
  const creativesCount = entity?.creatives?.length || 0;
  const commentsCount = countEntityComments(comments, entity, currentDraftID);

  return (
    <Accordion
      initialValue={false}
      onCallbackChangeExpanded={setIsExpanded}
      title={accordionTitle}
      variantTitle="subtitle1"
      titleAlign="left"
      iconTitle={<LayersIcon sx={{ fontSize: 18, color: "text.secondary" }} />}
      sx={{
        bgcolor: "background.paper",
        borderRadius: "12px !important",
        borderColor: "divider",
        ".MuiAccordionSummary-root": {
          px: 2,
          py: 0.5,
        },
        "& .MuiAccordionDetails-root": {
          px: 2,
          pt: 0,
          pb: 1.5,
        },
      }}
      sxTitle={{ fontWeight: 700 }}
      actionsComponent={
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            flexWrap: "wrap",
            justifyContent: "flex-end",
            mr: 0.5,
          }}
        >
          <Typography variant="caption" color="text.secondary">
            {[
              formatApprovalCountLabel(
                textsCount,
                CAMPAIGN_APPROVAL_ENTITY_TEXTS_COUNT,
                CAMPAIGN_APPROVAL_ENTITY_TEXTS_COUNT_SINGLE,
                t
              ),
              formatApprovalCountLabel(
                creativesCount,
                CAMPAIGN_APPROVAL_ENTITY_CREATIVES_COUNT,
                CAMPAIGN_APPROVAL_ENTITY_CREATIVES_COUNT_SINGLE,
                t
              ),
            ].join(" · ")}
          </Typography>
          {commentsCount > 0 ? (
            <Typography
              variant="caption"
              sx={{ color: "primary.main", fontWeight: 600 }}
            >
              {formatApprovalCountLabel(
                commentsCount,
                CAMPAIGN_APPROVAL_ENTITY_COMMENTS_COUNT,
                CAMPAIGN_APPROVAL_ENTITY_COMMENTS_COUNT_SINGLE,
                t
              )}
            </Typography>
          ) : null}
        </Box>
      }
    >
      <ApprovalEntityCard
        token={token}
        campaignID={campaignID}
        entity={entity}
        isExpanded={isExpanded}
        comments={comments}
        currentDraftID={currentDraftID}
        commentsLocked={commentsLocked}
        isSubmittingComment={isSubmittingComment}
        onSubmitSpecificComment={onSubmitSpecificComment}
      />
    </Accordion>
  );
};

export default AdAccordion;
